exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#editProjectAccess .levels-container .input-container[data-v-c0fd3d88]{min-height:30px;margin-bottom:0}#editProjectAccess .remove-field-btn[data-v-c0fd3d88]{top:12px}#editProjectAccess .levels-container .single-level-wrapper h3[data-v-c0fd3d88]{margin-top:0}", ""]);

// exports
